import { render, staticRenderFns } from "./_base-button-genre.vue?vue&type=template&id=62848d86"
import script from "./_base-button-genre.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-button-genre.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports